/**
 * back service
 */
angular.module('impactx').service('BackService', BackService);

BackService.$inject = ['$q', '$timeout'];

function BackService($q, $timeout) {

    this.back = function(checkBeforeAction) {
        
        // We check first whether navigation back is possible.
        if(window.history.length === 1) {
            try {
                console.log('BackService: Do not go back!');
            }catch(e){}
            return;
            //return $q.when();    

        }
        // IE problem: we need this timeout here to make sure the redirect will wait to the next digest cycle.
        // this prevents IE to run into infinite digest loops
        $timeout(function() {
            window.history.back();
        }, 0);
        return $q.when();
    };
}